import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=7afc49cd&scoped=true"
import script from "./tel.vue?vue&type=script&lang=js"
export * from "./tel.vue?vue&type=script&lang=js"
import style0 from "./tel.vue?vue&type=style&index=0&id=7afc49cd&prod&scoped=true&lang=scss"
import style1 from "./tel.vue?vue&type=style&index=1&id=7afc49cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc49cd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
